<ng-sidebar-container>
    <ng-sidebar #sidebar [(mode)]="sidebarMode" [(opened)]="isSidebarOpen">
        <frontsidebar
            (onSidebarLoaded)="refreshSidebar()"
            (onSidebarToggle)="toggleSidebar()"
            [nurseries]="nurseries"
            [isInsideNursery]="true"
            [isInsidePhotosphere]="true"
            [isBack]="isBack"
        ></frontsidebar>
    </ng-sidebar>
    <div ng-sidebar-content class="h-100">
        <div class="container-fluid p-0 h-100 position-relative">
            <photosphere [isBack]="isBack" [nurseryUUID]="nurseryUUID" [sphereUUID]="sphereUUID"></photosphere>
            <button
                class="btn"
                (click)="toggleSidebar()"
                style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: white;
                    border-radius: 0;
                    transition: transform 0.3s cubic-bezier(0, 0, 0.3, 1);
                "
                [ngStyle]="{ 'left.px': menuButtonMarginLeft }"
            >
                <i class="fas fa-bars"></i>
            </button>
        </div>
    </div>
</ng-sidebar-container>
